import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

// Define an async thunk to fetch data from the API

export const fetchProductList = createAsyncThunk(
  "subscription/fetchProductList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/payment/product-list");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createNewSubscription = createAsyncThunk(
  "subscription/createNewSubscription",
  async ({ user_id, product_id, community_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "payment/multi-community-subscription",
        {
          user_id,
          product_id,
          community_id,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const addSubscriptionDetails = createAsyncThunk(
  "subscription/addSubscriptionDetails",
  async ({ user_id, product_id, community_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "payment/subscription-details",
        {
          user_id,
          product_id,
          community_id,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchUserSubscriptionsById = createAsyncThunk(
  "subscription/fetchUserSubscriptionsById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/payment/user-subscription-information/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const cancelSubscription = createAsyncThunk(
  "subscription/createNewSubscription",
  async ({ user_id, subscription_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "payment/subscription-cancelation",
        {
          user_id,
          subscription_id,
        }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return []; // Return an empty array instead of rejecting
      }
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
